// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import RecordDetails from '../core/record-details';
import RememberMapping from '../search-data/remember-mapping';
import MappingDetailButtons from './mapping-detail-buttons';

// Styles
import './mapping-detail.scss';

function MappingDetail({
    bulkMapping,
    cancelMapping,
    fetched,
    fetching,
    hasAccessByType,
    isTabActive,
    mapItem,
    mappingData,
    mappingGoToNextMediaItem,
    mappingReset,
    mappingResetContentType,
    mappingSetMassMapping,
    mappingSetShowMessage,
    mappingSetShowRememberMapping,
    mappingSkipMassMapping,
    massMapping,
    massShell,
    mediaItemData,
    rememberMappingData,
    response,
    selectFirstTab,
    showMessage,
    showRememberMapping,
}) {
    const getMappingDetailButtonsProps = () => ({
        cancelMapping,
        fetched,
        hasAccessByType,
        isTabActive,
        mapItem,
        mappingData,
        mappingGoToNextMediaItem,
        mappingReset,
        mappingResetContentType,
        mappingSetMassMapping,
        mappingSetShowMessage,
        mappingSetShowRememberMapping,
        mappingSkipMassMapping,
        massMapping,
        massShell,
        mediaItemData,
        rememberMappingData,
        selectFirstTab,
        showRememberMapping,
    });

    const getRecordDetailsProps = () => ({
        detailExpandIcon: 'list showlisticon',
        whitelistKeys: [
            'echostarId',
            'episodeName',
            'franchiseEchostarId',
            'episodeEchostarId',
            'roviProgramId',
            'guid',
            'title',
            'showName',
        ],
    });

    const getRememberMappingProps = () => {
        const echostarIds = isRecordShow()
            ? {
                  episodeEchostarId: get(mappingData, 'episode.title')
                      ? get(mappingData, 'episode.echostarId') || 'pending'
                      : undefined,
                  franchiseEchostarId: get(mappingData, 'franchise.title')
                      ? get(mappingData, 'franchise.echostarId') || 'pending'
                      : undefined,
              }
            : {
                  echostarId: get(mappingData, 'franchise.echostarId') || 'pending',
              };

        return {
            mediaItemData: {...echostarIds, ...mediaItemData},
            fetched,
            response,
        };
    };

    const isRecordShow = () => get(mappingData, 'franchise.echostarContentType') === 'SRM';

    const shouldFullyMap = () => !get(mappingData, 'episode') && isRecordShow() && !massMapping && !bulkMapping;

    const renderMappingButtons = () =>
        (!massShell ? <MappingDetailButtons {...getMappingDetailButtonsProps()} /> : null);

    const renderMappingResponseRecord = (type) => {
        const {echostarId, title, ...rest} = get(mappingData, type) || {};
        const echostarIdField = isRecordShow() ? `${type}EchostarId` : 'echostarId';
        const recordData = {
            [echostarIdField]: echostarId || 'pending',
            title,
            ...rest,
        };

        return title ? <RecordDetails {...getRecordDetailsProps()} searchData={[recordData]} /> : null;
    };

    const renderRememberMapping = () =>
        (showRememberMapping ? <RememberMapping {...getRememberMappingProps()} /> : null);

    return massMapping || showMessage || shouldFullyMap() ? (
        <div className="mapping-detail--message">
            <RecordDetails {...getRecordDetailsProps()} keyOrder="mediaItems" searchData={[mediaItemData]} />
            <div className="mapping-detail--map-message">
                {fetched ? 'has been mapped to...' : 'will be mapped to...'}
            </div>
            {renderMappingResponseRecord('franchise')}
            {renderMappingResponseRecord('episode')}
            {renderRememberMapping()}
            {!fetching ? renderMappingButtons() : null}
        </div>
    ) : null;
}

MappingDetail.propTypes = {
    bulkMapping: PropTypes.bool,
    cancelMapping: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    hasAccessByType: PropTypes.func.isRequired,
    isTabActive: PropTypes.func,
    mapItem: PropTypes.func.isRequired,
    mappingData: PropTypes.object,
    mappingGoToNextMediaItem: PropTypes.func.isRequired,
    mappingReset: PropTypes.func.isRequired,
    mappingResetContentType: PropTypes.func.isRequired,
    mappingSetMassMapping: PropTypes.func,
    mappingSetShowMessage: PropTypes.func.isRequired,
    mappingSetShowRememberMapping: PropTypes.func.isRequired,
    mappingSkipMassMapping: PropTypes.func.isRequired,
    massMapping: PropTypes.bool,
    massShell: PropTypes.bool,
    mediaItemData: PropTypes.object,
    rememberMappingData: PropTypes.object,
    response: PropTypes.array,
    selectFirstTab: PropTypes.func,
    showMessage: PropTypes.bool,
    showRememberMapping: PropTypes.bool,
};

export default MappingDetail;
